
import { AnimatePresence } from "framer-motion";
import ThinkingVisual from "./ThinkingVisual";
import SearchResultBox from "./SearchResultBox";
import SearchInput from "./search/SearchInput";
import { useSearch } from "./search/useSearch";

interface SearchBarProps {
  isAISearch?: boolean;
}

const SearchBar = ({ isAISearch = false }: SearchBarProps) => {
  const {
    query,
    setQuery,
    isThinking,
    searchResult,
    chatId,
    handleSearch,
  } = useSearch();

  const handleFormSubmit = async (e: React.FormEvent) => {
    await handleSearch(e);
  };

  const handleLike = () => {
    handleSearch(null);
  };

  return (
    <div className="w-full space-y-8">
      <SearchInput
        query={query}
        onQueryChange={setQuery}
        onSubmit={handleFormSubmit}
        isAISearch={isAISearch}
      />

      {isAISearch && isThinking && (
        <ThinkingVisual isThinking={isThinking} />
      )}

      {isAISearch && searchResult && !isThinking && (
        <SearchResultBox 
          result={searchResult} 
          chatId={chatId}
          onLike={handleLike}
        />
      )}
    </div>
  );
};

export default SearchBar;
